import type { ApiError } from "@entrilia/shared/api/types";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import { logError } from "@entrilia/shared/logging";
import type { InvestorCommunicationInfo } from "../../api/types/investorCommunicationsTypes";
import NoDataResult from "../common/NoDataResult";
import NewsHeroCard from "./NewsHeroCard";
import NewsHeroCardSkeleton from "./NewsHeroCardSkeleton";
import NewsItemSummary from "./NewsItemSummary";

interface Props {
  latestNews: InvestorCommunicationInfo | undefined;
  loading: boolean;
  fetchError: ApiError | undefined;
  newsPagePath: string;
  heroLayout?: boolean;
}

const NewsWidgetContent = ({ latestNews, loading, fetchError, newsPagePath, heroLayout }: Props) => {
  if (fetchError) {
    logError(fetchError, "[NewsWidgetContent] fetchError");
    return <DataLoadingFailed title="Failed to load news" />;
  }

  if (loading) {
    return heroLayout ? <NewsHeroCardSkeleton /> : <InlineLoader />;
  }

  if (latestNews === undefined) {
    return <NoDataResult text="No news yet" />;
  }

  const newsItemPath = `${newsPagePath}/${latestNews.id}`;

  if (heroLayout) {
    return <NewsHeroCard item={latestNews} to={newsItemPath} />;
  }

  return <NewsItemSummary item={latestNews} to={newsItemPath} />;
};

export default NewsWidgetContent;
